module.exports = __webpack_public_path__ + "img/clip-3.51a54384.png";